/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EscalationPolicy, EscalationPresetType } from '../../lib/wwg.classes';

@Component({
  selector: 'wwg-escalation-policy',
  templateUrl: './escalation-policy.component.html'
})

export class EscalationPolicyComponent {

  public _model;

  public types: string[] = [
    EscalationPresetType.Default,
  ];

  @Input() get model() {
    return this._model;
  }

  @Output() modelChange = new EventEmitter();

  set model(model: EscalationPolicy) {
    this._model = model;
    this.modelChange.emit(this._model);
  }

  addEscalationPolicy() {
    this.model = new EscalationPolicy();
  }

  remove() {
    this.model = null;
  }
}
